import { render, staticRenderFns } from "./OrderBarrelDetails.vue?vue&type=template&id=42abacfd&"
import script from "./OrderBarrelDetails.vue?vue&type=script&lang=js&"
export * from "./OrderBarrelDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderBarrelDetails.vue?vue&type=style&index=0&id=42abacfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports